import { uploadActions } from "@common/redux/upload/actions";
import { IUploadFileReducerState } from "@common/redux/upload/interface";

export const initialState = {
  file: {},
  errors: {
    uploadFile: "",
    fetchFile: "",
  },
};

export const fileReducer = (
  state: IUploadFileReducerState = initialState,
  action: { type: string; payload: any }
) => {
  switch (action.type) {
    case uploadActions.UPLOAD_FILE:
      return {
        ...state,
        errors: { ...state.errors, uploadFile: "" },
      };

    case uploadActions.UPLOAD_FORM_FILE:
      const { file } = action.payload;
      return {
        ...state,
        file: file,
      };
      
  case uploadActions.UPLOAD_FORM_FILES:  
      return {         
        ...state,
      };
    

    case uploadActions.FETCH_FILE:
      return {
        ...state,
        errors: { ...state.errors, fetchFile: "" },
      };

    default:
      return { ...state };
  }
};
